import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { AuthService } from "../service/auth.service";
import { map, of, switchMap } from "rxjs";

@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate {
  private hydrated = false;

  constructor(private auth: AuthService, private router: Router) {}

  canActivate() {
    // Première navigation: hydrate() pour récupérer /auth/me
    const source$ = this.hydrated
      ? of(true)
      : this.auth.hydrate().pipe(map(() => true));
    this.hydrated = true;

    return source$.pipe(
      switchMap(() => this.auth.user$),
      map((user) => {
        if (user) return true;
        this.router.navigate(["/login"]);
        return false;
      })
    );
  }
}
